"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    type: Number,
    item: Object
  },
  created: function created() {},
  methods: {
    lookDetails: function lookDetails(e) {
      window.open(e);
    }
  }
};